<template>
  <div class="io-confirmation-card">
    <p
      class="text-regular"
      v-html="confirmationText"
    />
    <BaseFormControls
      @previous="$emit('close')"
      @next="submitAction"
    >
      <template #previous>
        {{ previous }}
      </template>
      <template #next>
        {{ next }}
      </template>
    </BaseFormControls>
  </div>
</template>

<script>
export default {
  name: 'IoConfirmation',

  props: {
    clear: String,
    action: {
      required: true,
      type: [String, Function],
    },
    method: {
      type: String,
      default: () => 'default',
    },
    confirmationText: {
      required: true,
      type: String,
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    previous: {
      type: String,
      default: 'Abbrechen',
    },
    next: {
      type: String,
      default: 'Bestätigen',
    },
  },
  methods: {
    submitAction() {
      if (typeof this.action === 'function') {
        this.action();
      } else if (this.clear) {
        /* eslint-disable no-undef */
        axios.post(this.clear, {
          _method: this.action,
        }).then((response) => {
          const message = response?.data?.message
            || response?.data?.messages?.[0]?.message
            || response?.data?.messages?.[0]
            || null;

          if (message) {
            this.responseHandler(response, true, true);
          } else if (this.method === 'clearAndSync') {
            GlobalEvents.fire('alert', [{
              message: 'Daten erfolgreich gelöscht. Synchro wurde gestartet und läuft nun im Hintergrund.',
              type: 'success',
            }]);
            GlobalEvents.fire('update-data-table');
          } else {
            GlobalEvents.fire('alert', [{
              message: 'Daten erfolgreich gelöscht.',
              type: 'success',
            }]);
            GlobalEvents.fire('update-data-table');
          }
        }).catch(() => {
          GlobalEvents.fire('alert', [{
            message: 'Daten konnten nicht gelöscht werden.',
            type: 'error',
          }]);
        });
        /* eslint-disable no-undef */
      }

      if (this.autoClose) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.io-confirmation-card {
  display: flex;
  flex-direction: column;

  &--actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    flex: 1;
    align-items: flex-end;
  }
}
</style>
